// extracted by mini-css-extract-plugin
export default {"modal_body_wrapper":"successCreateEvent_modal_body_wrapper__4LmWQ","modal_body":"successCreateEvent_modal_body__rhCYa","btns":"successCreateEvent_btns__n7PCu"};